'use no memo';

import type { Table as TableT } from '@tanstack/table-core';

import { cn } from '@repo/lib/cn';
import { Fragment } from 'react';

import { Skeleton } from '@/components/ui/skeleton';
import { TableCell, TableRow } from '@/components/ui/table';
import { useMediaQuery } from '@/hooks/media-query';

interface TanstackTableLoadingProps<TData> {
  table: TableT<TData>;
}

export default function TanstackTableLoading<TData>(tanstackTableLoadingProps: TanstackTableLoadingProps<TData>) {
  const { table } = tanstackTableLoadingProps;
  const breakpoint = useMediaQuery('md');

  if (breakpoint) {
    return Array.from({ length: 20 }, (_, index) => (
      <TableRow key={index}>
        {table.getHeaderGroups().map((headerGroup) =>
          headerGroup.headers.map((header, index, headers) => {
            const isLast = index === headers.length - 1;
            return (
              <TableCell key={header.id} className={'px-3 py-1'}>
                <Skeleton className={cn('z-0 w-full rounded-sm', isLast ? 'ml-auto h-10 w-10' : 'h-4')} />
              </TableCell>
            );
          })
        )}
      </TableRow>
    ));
  }
  return Array.from({ length: 3 }, (_, index) => (
    <div key={index} className={'border-border-primary bg-surface-primary flex w-full flex-col rounded-2xl border py-4'}>
      {table.getHeaderGroups().map((headerGroup) =>
        headerGroup.headers.map((header, index, headers) => {
          const isLast = index === headers.length - 1;
          return (
            <div key={header.id} className={cn('flex min-h-7 items-center justify-between gap-3 px-4', isLast ? 'border-border-primary mt-4 border-t px-4 pt-4' : null)}>
              {isLast ? (
                <Skeleton className={'ml-auto h-10 w-10'} />
              ) : (
                <Fragment>
                  <Skeleton className={'h-4 w-14 shrink-0'} />
                  <Skeleton className={'h-4 w-full'} />
                </Fragment>
              )}
            </div>
          );
        })
      )}
    </div>
  ));
}
